import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function NotAllowed() {
  const navigate = useNavigate();
  useDocumentTitle("Not allowed");
  return (
    <div className="min-h-[60vh] w-full flex flex-col items-center justify-center gap-4 py-24 px-6 text-center" data-testid="not-allowed">
      <ShieldAlert className="h-10 w-10 text-rose-500" strokeWidth={1.5} />
      <h1 className="font-display text-2xl font-semibold">Not allowed</h1>
      <p className="text-sm text-muted-foreground">You don't have access to this area.</p>
      <Button variant="outline" className="rounded-md" onClick={() => navigate("/app")} data-testid="not-allowed-back">Back to app</Button>
    </div>
  );
}
